export default __webpack_public_path__ + "static/media/pet2vet.ddbb58a3.gif";